import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import EmptyStateView from "../../EmptyStateView";

export default function DialerAccessEmptyState() {
  const navigate = useNavigate();
  const { workspaceSlug } = useParams();

  const handleAddUser = () => {
    navigate(`/${workspaceSlug}/dialer-ai/add-user`);
  };

  return <EmptyStateView buttonText="Add User" onButtonClick={handleAddUser} />;
}
